import type { Job } from '@/types/job';

export const START_JOB_REQUIRES_LINE_ITEMS_MESSAGE =
  'Add at least one line item before starting the job. Open Finances > Line items to add the job scope first.';

export function hasJobLineItems(job: Pick<Job, 'lineItems'> | null | undefined): boolean {
  return Array.isArray(job?.lineItems) && job.lineItems.some(Boolean);
}
